import React from 'react';

import { ProfileImage, ProfileImageProps } from '@xingternal/profile-image';

import withLink from './components/withLink/withLink';

type Props = Pick<ProfileImageProps, 'src' | 'size' | 'className'> & {
  name?: string | undefined;
};

const CompanyLogo: React.FC<Props> = ({ src, name, ...props }) => (
  <ProfileImage type="company" profileName={name} src={src} {...props} />
);

export const CompanyLogoWithLink = withLink(CompanyLogo);

export { CompanyLogo };
